import styled from 'styled-components';

export const AccountManagementContainerStyled = styled.div`
  .show_loading {
    height: calc(100vh - 85px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .layer_one {
    display: flex;
  }
  .layer_two {
    margin-top: 45px;
    .tab_show {
      margin-bottom: 30px;
    }
    .button_show {
      margin-bottom: 15px;
      display: flex;
      justify-content: space-between;
      .search_layer {
        width: 50%;
      }
      .btn {
        width: 15%;
      }
    }
    .table_show {

    }
  }
  @media (max-width: ${({ theme }) => theme.SCREENS.TABLET}) {
    .layer_two {
      .button_show {
        .btn {
          width: 20%;
        }
      }
    }
  }
  @media (max-width: ${({ theme }) => theme.SCREENS.MINI_TABLET}) {
    .layer_two {
      .button_show {
        .btn {
          width: 25%;
        }
      }
    }
  }
`;
